export function getMilesFromMeters(meters: number) {
  return meters * 0.000621371192;
}

export function getMetersFromMiles(miles: number) {
  return miles * 1609.34;
}
